export const ShopMenuWrapperPlasmicProps = {
  children: {
    type: "slot",
  },
  className: {
    type: "string",
    defaultValue: "",
  },
  slug: {
    type: "string",
    description:
      "The slug to fetch the menu for. If not provided, the promotional store slug will be used.",
  },
  countryCode: {
    type: "string",
  },
};
